import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Nav/nav';
import { css } from '@patternfly/react-styles';
import AngleLeftIcon from '@patternfly/react-icons/dist/js/icons/angle-left-icon';
import AngleRightIcon from '@patternfly/react-icons/dist/js/icons/angle-right-icon';
import { isElementInView } from '../../helpers/util';
import { NavContext } from './Nav';
export var NavList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NavList, _React$Component);

  function NavList() {
    var _this;

    _classCallCheck(this, NavList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NavList).apply(this, arguments));
    _this.state = {
      scrollViewAtStart: false,
      scrollViewAtEnd: false
    };
    _this.navList = React.createRef();

    _this.handleScrollButtons = function () {
      var container = _this.navList.current;

      if (container) {
        // check if it elements are in view
        var scrollViewAtStart = isElementInView(container, container.firstChild, false);
        var scrollViewAtEnd = isElementInView(container, container.lastChild, false);

        _this.setState({
          scrollViewAtStart: scrollViewAtStart,
          scrollViewAtEnd: scrollViewAtEnd
        });

        _this.context.updateIsScrollable(!scrollViewAtStart || !scrollViewAtEnd);
      }
    };

    _this.scrollLeft = function () {
      // find first Element that is fully in view on the left, then scroll to the element before it
      var container = _this.navList.current;

      if (container) {
        var childrenArr = Array.from(container.children);
        var firstElementInView;
        var lastElementOutOfView;

        for (var i = 0; i < childrenArr.length && !firstElementInView; i++) {
          if (isElementInView(container, childrenArr[i], false)) {
            firstElementInView = childrenArr[i];
            lastElementOutOfView = childrenArr[i - 1];
          }
        }

        if (lastElementOutOfView) {
          container.scrollLeft -= lastElementOutOfView.scrollWidth;
        }

        _this.handleScrollButtons();
      }
    };

    _this.scrollRight = function () {
      // find last Element that is fully in view on the right, then scroll to the element after it
      var container = _this.navList.current;

      if (container) {
        var childrenArr = Array.from(container.children);
        var lastElementInView;
        var firstElementOutOfView;

        for (var i = childrenArr.length - 1; i >= 0 && !lastElementInView; i--) {
          if (isElementInView(container, childrenArr[i], false)) {
            lastElementInView = childrenArr[i];
            firstElementOutOfView = childrenArr[i + 1];
          }
        }

        if (firstElementOutOfView) {
          container.scrollLeft += firstElementOutOfView.scrollWidth;
        }

        _this.handleScrollButtons();
      }
    };

    return _this;
  }

  _createClass(NavList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleScrollButtons, false);
      this.handleScrollButtons();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleScrollButtons, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          children = _a.children,
          className = _a.className,
          ariaLeftScroll = _a.ariaLeftScroll,
          ariaRightScroll = _a.ariaRightScroll,
          props = __rest(_a, ["children", "className", "ariaLeftScroll", "ariaRightScroll"]);

      var _this$state = this.state,
          scrollViewAtStart = _this$state.scrollViewAtStart,
          scrollViewAtEnd = _this$state.scrollViewAtEnd;
      return React.createElement(NavContext.Consumer, null, function (_ref) {
        var isHorizontal = _ref.isHorizontal;
        return React.createElement(React.Fragment, null, isHorizontal && React.createElement("button", {
          className: css(styles.navScrollButton),
          "aria-label": ariaLeftScroll,
          onClick: _this2.scrollLeft,
          disabled: scrollViewAtStart
        }, React.createElement(AngleLeftIcon, null)), React.createElement("ul", Object.assign({
          ref: _this2.navList,
          className: css(styles.navList, className),
          onScroll: _this2.handleScrollButtons
        }, props), children), isHorizontal && React.createElement("button", {
          className: css(styles.navScrollButton),
          "aria-label": ariaRightScroll,
          onClick: _this2.scrollRight,
          disabled: scrollViewAtEnd
        }, React.createElement(AngleRightIcon, null)));
      });
    }
  }]);

  return NavList;
}(React.Component);
NavList.contextType = NavContext;
NavList.defaultProps = {
  ariaLeftScroll: 'Scroll left',
  ariaRightScroll: 'Scroll right'
};